module.exports = __webpack_public_path__ + "img/tips.7c5aa8d0.png";